import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f8800aa&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=9f8800aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8800aa",
  null
  
)

component.options.__file = "index.vue"
export default component.exports